export const rgptWalkthroughLoomEmbedUrl =
  "https://www.loom.com/embed/8daf9a0209f345f78f64bf4ceae420c4?sid=e7e8ff10-2536-4ccb-a7c8-5644b8a23aac?hide_owner=true&hide_share=true&hide_title=true&hideEmbedTopBar=true"

export const tomboWalkthroughYoutubeId = "t8KjHrdCnVU"

export const rgptWalkthroughLoomEmbedUrlYouTube = `https://www.youtube.com/embed/${tomboWalkthroughYoutubeId}?ecver=1&autoplay=1&iv_load_policy=3&rel=0&showinfo=0&yt:stretch=16:9&autohide=1&color=red&width=560&width=560`
